import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {deleteCustomFieldChoices} from "../../../redux/Actions/customFields.actions";

export const useCustomFieldChoicesTableActions = () => {
  const dispatch = useDispatch();
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [selectedCustomFieldChoice, setSelectedCustomFieldChoice] = useState("");

  const handleDeleteCustomFieldChoice = () => {
    dispatch(
      deleteCustomFieldChoices(selectedCustomFieldChoice.id, () =>
        setDeleteModalStatus(false)
      )
    );
  };

  const handleActionSelection = useCallback((action, data) => {
    switch (action) {
      case "Edit":
        setSelectedCustomFieldChoice(data);
        setEditModalStatus(true);
        break;
      case "Delete":
        setSelectedCustomFieldChoice(data);
        setDeleteModalStatus(true);
        break;
    }
  }, []);

  return {
    deleteModalStatus,
    deleteCustomFieldChoice: handleDeleteCustomFieldChoice,
    editModalStatus,
    handleActionSelection,
    selectedCustomFieldChoice,
    setDeleteModalStatus,
    setEditModalStatus,
  };
};
